
import React from 'react';
import { SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function SortableBracketAthlete({ athlete, pouleId, isBye = false }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ 
        id: isBye ? `bye-${Math.random()}` : `ath-${athlete?.id}`,
        disabled: isBye || !athlete,
        data: { type: 'athlete', athlete, fromPoule: pouleId }
    });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
        opacity: isDragging ? 0.3 : 1,
        fontSize: '13px',
        padding: '8px 12px',
        backgroundColor: 'white',
        border: '1px solid #edf2f7',
        borderRadius: '6px',
        marginBottom: '4px',
        cursor: (isBye || !athlete) ? 'default' : 'grab',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        zIndex: isDragging ? 10 : 1
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: isBye || !athlete ? '#cbd5e0' : '#cbd5e0' }} />
            <span style={{ fontWeight: '500', flex: 1, color: '#2d3748' }}>
                {athlete ? athlete.name : (isBye ? "QUALIFIÉ D'OFFICE" : "-")}
            </span>
            {athlete?.club && <span style={{ fontSize: '11px', color: '#a0aec0' }}>{athlete.club}</span>}
        </div>
    );
}

const EliminationBracket = ({ athletes, pouleId }) => {
  if (!athletes || athletes.length < 2) return null;

  let size = 2;
  while (size < athletes.length) size *= 2;

  const rounds = [];
  
  const firstRound = [];
  for (let i = 0; i < size / 2; i++) {
    const a1 = athletes[i];
    const a2 = athletes[size - 1 - i];
    firstRound.push({ p1: a1, p2: a2, isBye: !a1 || !a2 });
  }
  rounds.push(firstRound);

  let currentRound = firstRound;
  let nextSize = size / 2;
  while (nextSize > 1) {
    const nextRound = [];
    for (let i = 0; i < nextSize / 2; i++) {
      const m1 = currentRound[i * 2];
      const m2 = currentRound[i * 2 + 1];
      const label1 = m1.isBye ? (m1.p1 || m1.p2 ? `Vainqueur Match ${i * 2 + 1}` : null) : `Vainqueur Match ${i * 2 + 1}`;
      const label2 = m2.isBye ? (m2.p1 || m2.p2 ? `Vainqueur Match ${i * 2 + 2}` : null) : `Vainqueur Match ${i * 2 + 2}`;
      nextRound.push({ p1: null, p2: null, label1: label1, label2: label2, isBye: false });
    }
    rounds.push(nextRound);
    currentRound = nextRound;
    nextSize /= 2;
  }

  const getRoundTitle = (roundIndex, totalRounds) => {
    const diff = totalRounds - 1 - roundIndex;
    if (diff === 0) return "Finale";
    if (diff === 1) return "Demi-finale";
    if (diff === 2) return "Quart de finale";
    return `Tour ${roundIndex + 1}`;
  };

  return (
    <div style={{ 
      display: 'flex', 
      gap: '20px', 
      padding: '10px 0', 
      overflowX: 'auto', 
      marginTop: '5px'
    }}>
      {rounds.map((round, rIdx) => (
        <div key={rIdx} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', minWidth: '180px' }}>
          <h5 style={{ textAlign: 'center', color: '#718096', fontSize: '10px', marginBottom: '10px', textTransform: 'uppercase' }}>
            {getRoundTitle(rIdx, rounds.length)}
          </h5>
          {round.map((match, mIdx) => (
            <div key={mIdx} style={{ marginBottom: '20px', position: 'relative' }}>
              <div style={{ 
                backgroundColor: 'white', 
                border: '1px solid #e2e8f0', 
                borderRadius: '8px', 
                padding: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
              }}>
                {rIdx === 0 ? (
                    <SortableContext items={[match.p1, match.p2].filter(Boolean).map(a => `ath-${a.id}`)} strategy={verticalListSortingStrategy}>
                        <SortableBracketAthlete athlete={match.p1} pouleId={pouleId} />
                        <SortableBracketAthlete athlete={match.p2} pouleId={pouleId} isBye={!match.p1 || !match.p2} />
                    </SortableContext>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <div style={{ padding: '8px 12px', fontSize: '13px', backgroundColor: 'white', border: '1px solid #edf2f7', borderRadius: '6px', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#cbd5e0' }} />
                            {match.label1 || "-"}
                        </div>
                        <div style={{ padding: '8px 12px', fontSize: '13px', backgroundColor: 'white', border: '1px solid #edf2f7', borderRadius: '6px', color: '#2d3748', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#cbd5e0' }} />
                            {match.label2 || "-"}
                        </div>
                    </div>
                )}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default EliminationBracket;
